<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: 'photo',
    },
    src: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showImg: false,
    }
  },
}
</script>

<template>
  <VLayout row wrap align-center>
    <VFlex xs4>
      <VSubheader style="height: 25px;">{{ label }}</VSubheader>
    </VFlex>

    <VFlex xs8>
      <div v-show="showImg">
        <img :src="src" alt="" class="mb-2" style="max-width: 100%;" />
      </div>
      <a href="#" @click="showImg = !showImg">
        {{ showImg ? `Hide ${text}` : `View ${text}` }}
      </a>
    </VFlex>
  </VLayout>
</template>
